import Components from './../Component';

export default class WaitingLines extends Components {

  constructor($) {
    super($);
  }

  get(element){
      let sec2time = (timeInSeconds) => {
          return Math.floor(parseFloat(timeInSeconds) / 60);
      };

              var serviceName = element.dataset.service;

              // XMLHttpRequest wrapper using callbacks
              var request = obj => {
                  return new Promise((resolve, reject) => {
                      var xhr = new XMLHttpRequest();
                  xhr.open(obj.method || "GET", obj.url);
                  if (obj.headers) {
                      Object.keys(obj.headers).forEach(key => {
                          xhr.setRequestHeader(key, obj.headers[key]);
                  });
                  }
                  xhr.onload = () => {
                        this.$(element).find('.refresh').removeClass('disabled');
                      if (xhr.status >= 200 && xhr.status < 300) {
                          resolve(xhr.response);
                      } else {
                          reject(xhr.statusText);
                      }
                  };
                  xhr.onerror = () => reject(xhr.statusText);
                  xhr.send(obj.body);
              });
              };

              request({url: '/waiting_lines/' + serviceName + '.json'})
                  .then(data => {
                  var queues = JSON.parse(data);

              queues.forEach(queue => {
                  var lines = document.querySelectorAll('.waiting_line-data[data-id="' + queue.id + '"]');

                    var dt = new Date();
                    var hours = (dt.getHours() < 10 ? '0' : '') + dt.getHours();
                    var minutes = (dt.getMinutes() < 10 ? '0' : '') + dt.getMinutes();

                  jQuery(element).find('.waiting_lines-time > span').text(hours+':'+minutes);

              if (lines.length > 0) {
                  for (var i = 0; i < lines.length; i++) {
                      var line = lines[i];
                      var minumimText = line.dataset.minimum;

                      var text = "-";
                      if (queue.estimatedWaitingTime === 0) {
                          text = minumimText;
                      } else if (queue.estimatedWaitingTime > 0) {
                          text = sec2time(queue.estimatedWaitingTime) + ' min.';
                      }
                      line.innerText = text;
                  }

              }

          });
          })
          .catch(error => {
                  console.log(error);
          });
  }

  init(index, element) {

    this.$(element).find('.refresh').on('click', function () {

      if (!this.$(element).find('.refresh').hasClass('disabled')) {
        this.get(element);
        this.$(element).find('.refresh').addClass('disabled');
      }
      return false;

    }.bind(this));

      this.get(element);
  }
}
